<template>
  <span
    v-if="isPc"
    style="display: inline-block;"
  >
    <v-menu
      offset-y
      z-index="9999"
    >
      <template
        #activator="{ on }"
      >
        <v-btn
          slot="activator"
          flat
          icon
          small
          color="info lighten-2"
          class="ma-0"
          v-on="on"
        >
          <v-icon
            :class="iconClass"
            small
          >help</v-icon>
        </v-btn>
      </template>
      <div>
        <v-card class="light-blue lighten-5">
          <v-card-text
            :style="{width: (width || 400) + 'px'}"
            style="max-height: 90vh;overflow: auto;"
            @click.stop
          >
            <slot />
          </v-card-text>
        </v-card>
      </div>
    </v-menu>
  </span>
  <span
    v-else
    style="vertical-align: text-bottom;"
  >
    <v-icon
      v-if="!$slots.activator"
      :class="iconClass"
      class="info--text text--lighten-2"
      small
      style="vertical-align: text-bottom;"
      @click="showSheet=true"
    >help</v-icon>
    <span
      v-else
      @click="showSheet=true"
    >
      <slot
        name="activator"
      />
    </span>

    <v-bottom-sheet
      v-if="showSheet"
      v-model="showSheet"
    >
      <v-sheet>
        <v-card flat>
          <v-card-text style="font-size: 16px;padding-bottom: 40px;max-height: 80vh;overflow: auto;">
            <slot />
          </v-card-text>
        </v-card>
      </v-sheet>
    </v-bottom-sheet>
  </span>
</template>
<script>
export default {
  props: {
    width: [Number, String],
    iconClass: [String, Object, Array],
  },
  data () {
    return {
      isPc: window.isPc,
      showSheet: false,
    }
  },
}
</script>
